import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HomePage } from "./pages/Home";
import { PetPage } from "./pages/Pet";
import { RoutinePage } from "./pages/Routine";
import { ChildHome } from "./pages/ChildHome";
import { ParentDashboard } from "./pages/ParentDashboard";
import { PinGate } from "./pages/PinGate";

export function App(): React.ReactElement {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-gray-50">
        <Routes>
          {/* Shared / legacy routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/pet" element={<PetPage />} />
          <Route path="/routine/:routineId" element={<RoutinePage />} />

          {/* Child routes */}
          <Route path="/child" element={<ChildHome />} />

          {/* Parent routes — access guarded by PIN gate */}
          <Route path="/pin" element={<PinGate />} />
          <Route path="/parent" element={<ParentDashboard />} />
          <Route path="/parent/*" element={<ParentDashboard />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}
